/* src/app/hire-person-search/hire-candidate-slider/hire-slider-skills-view/hire-slider-skills-view.component.scss */
.skills-chip {
  background-color: #EFF7F8;
  border-radius: 23px;
  min-height: auto;
  font-weight: 500;
  font-size: 12px;
  padding: 4px 12px;
  gap: 4px;
  color: #484b59;
  margin: 0 6px 6px 0;
}
/*# sourceMappingURL=hire-slider-skills-view.component-NVZOG5QE.css.map */
